import type { LucideIcon } from "lucide-react";
import { Monitor, Smartphone, Tablet } from "lucide-react";

export type BreakpointPreset = {
  key: string;
  label: string;
  width: number | null;
  icon?: LucideIcon;
};

export const BREAKPOINT_PRESETS: BreakpointPreset[] = [
  { key: "base", label: "Base", width: null, icon: Monitor },
  { key: "tablet", label: "Tablet", width: 1079, icon: Tablet },
  { key: "mobile", label: "Mobile", width: 767, icon: Smartphone },
];
